import staticText from 'car-insurance/assets/static-content/dashboard.json';
import { useCarInsuranceContext } from 'car-insurance/context';
import { trackCIEditQuotePencilButton } from 'car-insurance/tracking';
import { useLocaleSpecificClient } from 'hooks/useSpecificClient';
import React from 'react';
import { Icon } from '../Icon';

export const EditQuoteButton: React.FC = () => {
  const {
    sidebars: { editQuoteSidebar },
  } = useCarInsuranceContext();

  const handleClick = () => {
    trackCIEditQuotePencilButton();
    editQuoteSidebar.setIsOpen(true);
  };

  const buttonText = useLocaleSpecificClient({
    ...staticText.quote.editButton,
  });

  return (
    <button
      onClick={handleClick}
      type="button"
      className="rounded-lg md:rounded-xl lg:rounded-lg sm:h-9 md:h-10 lg:h-11 !p-0 group w-full md:py-2 bg-white border border-primary-500 md:text-base font-semibold text-primary-800 flex justify-center items-center gap-2 lg:px-4 md:pl-4 md:pr-3 sm:text-sm sm:py-1 hover:bg-primary-900 transition-colors"
    >
      <span className="text-base md:text-lg lg:text-xl">{buttonText}</span>
      <Icon
        useGoogleMaterial
        name="edit"
        className="!text-xl text-primary-800 !leading-none group-hover:text-white"
      />
    </button>
  );
};
